import './AllergyIntolerance.css';
import { useState, useEffect } from "react";

const AllergyIntolerance = (props) => {
    const [data, setData] = useState("")
    useEffect(() => {
        setData(props.getData())
    }, [props])
    const [selectedText, setselectedText] = useState("")

    return (
        <div className="resourceTextContainer">
            {data?.objects?.map((item, index) => (
                <p key={index} className={`${index === data?.objects?.length - 1 ? 'lastRow' : ''} ${selectedText===item?.resource?.code?.coding[0]?.display?"active":""} cursor-pointer`} onClick={() =>{ 
                    props.setResourceListData(item)
                    setselectedText(item?.resource?.code?.coding[0]?.display)
                    }}>
                    {item?.resource?.code?.coding[0]?.display} [{item?.resource?.code?.coding[0]?.code}]
                </p>
            ))}
        </div>
    );
}

export default AllergyIntolerance;